export default __webpack_public_path__ + "static/media/freelancer.59a01d73.png";